import { alias, deserialize, list, object, serializable } from 'serializr';
import { Deserializable } from '@models/deserializable';
import {
  QtestIssueField
} from '@modules/test-development/models/qtest-issue-field';

export class QTestProject implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public name: string;

  @serializable(alias('fields', list(object(QtestIssueField))))
  public fields: QtestIssueField[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(QTestProject, input));
  }
}
